import React, {StrictMode, useEffect, useState} from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import MainSearchBox from './MainSearchBox'
import SearchBox from 'js/components/searchHomepageWithFilters/containers/SearchBox'
import store from 'js/components/shared/store'
import * as constants from './constants'
import {createPortal} from 'react-dom';
import {pushDynamicVariable} from 'js/helpers/contentsquare';
import {homeMobileSearchVersionEvent} from 'js/helpers/gtm';

/**
 * Search box with filters used for AB test on home page
 * If  Cookie present filters are enabled
 * and video banner for desktop applied html/src/js/components/homePageBanner
 * Created on base of search component styles
 *
 * @param searchBoxData<Object> - window.drupalSettings.widgets.searchBox
 * @param filtersData<Object>   - window.drupalSettings.widgets.filters
 * @param filtersTypes<Array>   - possible values ['dates', 'rooms', 'more', 'code']
 * @param activeFilter<String>  - defines the opened by default filter if is set.
 *                                Possible: 'dates', rooms', 'more'
 * @param pageIndex<Number>     - The index of current HTML page
 * @param containerId<String>   - id of root DOM element for search app.
 * @param sticky<Boolean>       - should search bar be sticky on page scroll
 *
 * @returns {*}
 */

const mobileWrapId = 'mobile-search-box'
const mobileWrapNode = document.getElementById(mobileWrapId)

// Render new searchbar for mobile screen only.
// Desktop version would be also replaced in the near future
const SearchBoxSwitcher = function (props) {
  const {variation} = props;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  const checkWindowSize = function () {
    setIsMobile(window.innerWidth <= 768)
  }

  useEffect(() => {
    if (isMobile && variation) {
      pushDynamicVariable({
        key: 'HP - New mobile search',
        value: variation,
      })
      homeMobileSearchVersionEvent(variation === 'variation1' ? 1 : 0)
    }
    window.addEventListener('resize', checkWindowSize)
    return function () {
      window.removeEventListener('resize', checkWindowSize)
    }
  }, []);

  return isMobile ? (createPortal(<MainSearchBox {...props} />, mobileWrapNode)) : (<SearchBox {...props} />)
}

const initSearchBox = ({
  containerId = 'search-box',
  ...props
}) => {
  mobileWrapNode.classList.add('loaded')

  render(
    <StrictMode>
      <Provider store={store}>
        <SearchBoxSwitcher {...props} />
      </Provider>
    </StrictMode>,
    document.getElementById(containerId),
  )
}


export {
  constants,
}
export default initSearchBox
